<template>
  <div style="width: 100%; height: 100%; position: relative;">
    <div style="width: 100%; height: 100%" ref="chartsDom" class="chartsDom"></div>
    <div class="cBg"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chartsDom",
  props: {
    list: Object,
  },
  data() {
    return {
      goToSchoolTwo: {},
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        this.$nextTick(() => { this.initNYNM(); });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
    this.$nextTick(() => {
      this.initNYNM();
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chartsDom).resize();
    });
  },
  methods: {
    initNYNM() {
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      let myChart = this.$echarts.init(this.$refs.chartsDom);
      // 2. 指定配置和数据

      let goToSchoolTwo = this.goToSchoolTwo.value;

      let color = ['#1C70DC', '#51EAFF', '#FFCD40', '#9D50F0', 'rgba(39, 220, 191, 1)', 'rgba(131, 255, 93, 1)'];
      let echartData = [
        { name: '设备1', value: '3720', },
        { name: '设备2', value: '2920', },
        { name: '设备3', value: '2200', },
        { name: '设备4', value: '1420', },
      ];

      let option = {
        color: color,
        legend: [{
          // type: 'scroll',
          // icon: 'circle',
          orient: 'vertical',
          bottom: 'center',
          left: '60%',
          align: 'auto',
          height: '80%',
          itemHeight: 10,
          itemWidth: 10,
          textStyle: {
            color: '#fff',
            fontSize:18
          },
          formatter: function (name) {
            let value = goToSchoolTwo.find(item => item.name == name).value
            return name + ' ' + value;
          },
          data: goToSchoolTwo,

        }],
        title: [
          {
            text: '100%',
            left: '23%',
            top: '40%',
            textStyle: {
              fontSize: 20,
              color: '#00f0ff',
              foontWeight: '500',
            },
          },
          {
            text: this.goToSchoolTwo.name,
            x: '25%',
            top: '51%',
            textStyle: {
              color: '#fff',
              fontSize: 18,
              fontWeight: '100',
            },
          },
        ],
        polar: {
          radius: ['44%', '50%'],
          center: ['50%', '50%'],
        },
        angleAxis: {
          max: 100,
          show: false,
        },
        radiusAxis: {
          type: 'category',
          show: true,
          axisLabel: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            type: 'pie',
            radius: ['62%', '53%'],
            center: ['30%', '50%'],
            data: goToSchoolTwo,
            hoverAnimation: false,
            itemStyle: {
              normal: {
                borderColor: '#364684',
                borderWidth: 2,
              },
            },
            labelLine: {
              show: false,
              normal: {
                show: false,
                length: 60,
                length2: 60,
                lineStyle: {
                  color: '#e6e6e6'
                },
              },
            },
            label: {
              show: false,
            },

          },
          {
            type: 'pie',
            name: '外细圆环',
            radius: ['70%', '68%'],
            center: ['30%', '50%'],
            hoverAnimation: false,
            clockWise: false,
            itemStyle: {
              normal: {
                color: '#fff3',
              },
            },
            label: {
              show: false,
            },
            data: [100],
          },
          {
            type: 'pie',
            name: '内层细圆环',
            radius: ['46%', '44%'],
            center: ['30%', '50%'],
            hoverAnimation: false,
            clockWise: false,
            itemStyle: {
              normal: {
                color: '#fff3',
              },
            },
            label: {
              show: false,
            },
            data: [100],
          },
        ],
      };
      // 其他各种图表一个原理
      // let index = 0;
      // setInterval(function () {
      //     // 这里的7 为x轴的长度
      //     if (index >= 7) {
      //         index = 0;
      //     }
      //     myChart.dispatchAction({
      //         type: "showTip", // 提示框
      //         seriesIndex: 0,
      //         dataIndex: index // 第 lightIndex 柱子高亮
      //     });
      //     index += 1;
      // }, 2000);
      // 3. 把配置给实例对象
      myChart.setOption(option);
      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
<style>
.cBg {
  position: absolute;
  top: 75px;
  left: 29px;
  width: 206px;
  height: 135px;
  background: url(../assets1/14.png) no-repeat center center / 100% 100%;
}
</style>
